const KEY = "ll_showtime_sessions_v1";

function safeParse(json, fallback) {
  try {
    const v = JSON.parse(json);
    return v ?? fallback;
  } catch {
    return fallback;
  }
}

function uid() {
  return "st_" + Math.random().toString(16).slice(2) + "_" + Date.now().toString(16);
}

export function loadShowtimeState() {
  const raw = localStorage.getItem(KEY);
  const state = safeParse(raw, null);

  if (state && Array.isArray(state.sessions) && state.currentSessionId) return state;

  const firstId = uid();
  const bootstrap = {
    currentSessionId: firstId,
    sessions: [
      {
        session_id: firstId,
        name: "My First Show",
        show_date: new Date().toISOString().slice(0, 10),
        status: "draft",
        lines: [],
        updated_at: Date.now(),
      },
    ],
  };

  localStorage.setItem(KEY, JSON.stringify(bootstrap));
  return bootstrap;
}

export function saveShowtimeState(state) {
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function createSession(state, { name, show_date } = {}) {
  const id = uid();
  const next = {
    ...state,
    currentSessionId: id,
    sessions: [
      {
        session_id: id,
        name: name || "New Show",
        show_date: show_date || new Date().toISOString().slice(0, 10),
        status: "draft",
        lines: [],
        updated_at: Date.now(),
      },
      ...state.sessions,
    ],
  };
  saveShowtimeState(next);
  return next;
}

export function setCurrentSession(state, id) {
  const exists = state.sessions.some((s) => s.session_id === id);
  if (!exists) return state;
  const next = { ...state, currentSessionId: id };
  saveShowtimeState(next);
  return next;
}

export function updateSessionMeta(state, id, patch) {
  const next = {
    ...state,
    sessions: state.sessions.map((s) =>
      s.session_id === id ? { ...s, ...patch, updated_at: Date.now() } : s
    ),
  };
  saveShowtimeState(next);
  return next;
}

export function updateLines(state, id, lines) {
  const next = {
    ...state,
    sessions: state.sessions.map((s) =>
      s.session_id === id ? { ...s, lines: lines || [], updated_at: Date.now() } : s
    ),
  };
  saveShowtimeState(next);
  return next;
}

export function deleteSession(state, id) {
  const remaining = state.sessions.filter((s) => s.session_id !== id);

  // always keep at least one
  if (remaining.length === 0) {
    const newId = uid();
    const next = {
      currentSessionId: newId,
      sessions: [
        {
          session_id: newId,
          name: "My First Show",
          show_date: new Date().toISOString().slice(0, 10),
          status: "draft",
          lines: [],
          updated_at: Date.now(),
        },
      ],
    };
    saveShowtimeState(next);
    return next;
  }

  const nextCurrent =
    state.currentSessionId === id ? remaining[0].session_id : state.currentSessionId;

  const next = {
    currentSessionId: nextCurrent,
    sessions: remaining,
  };

  saveShowtimeState(next);
  return next;
}
